import styled from "styled-components";

export const BottomBanner = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  padding: 1rem;
  animation: slide-up 0.3s ease-out;

  @keyframes slide-up {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const BannerCard = styled.div`
  position: relative;
  width: 100%;
  max-width: 640px;
  background-color: #ffffff;
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  padding: 1.5rem;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    padding: 1.25rem;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${(props) => props.theme.colors.font.grey2};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  border-radius: 6px;

  &:hover {
    background-color: ${(props) => props.theme.colors.secondary};
    color: ${(props) => props.theme.colors.font.grey1};
  }
`;

export const FormTitle = styled.h3`
  font-size: ${(props) => props.theme.fontSizes.medium};
  font-weight: 600;
  color: ${(props) => props.theme.colors.font.grey1};
  margin: 0 0 0.25rem;
  padding-right: 1.5rem;
`;

export const QuestionLabel = styled.p`
  font-size: ${(props) => props.theme.fontSizes.small};
  color: ${(props) => props.theme.colors.font.tertiary};
  margin: 0 0 0.75rem;
`;

export const NpsRow = styled.div`
  display: flex;
  /* The modal's own max-width never leaves room for 11 circles at a
   * comfortable size (it caps out well under what that would need), on
   * any screen — so the row always divides itself into 11 equal slots
   * instead of wrapping the last couple onto their own line. */
  flex-wrap: nowrap;
  gap: 0.25rem;
  margin-bottom: 0.375rem;
`;

export const NpsCircle = styled.button<{ $selected: boolean }>`
  flex: 1 1 0;
  min-width: 0;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 1px solid ${(props) => (props.$selected ? props.theme.colors.accentColor : props.theme.colors.border)};
  background-color: ${(props) => (props.$selected ? props.theme.colors.accentColor : "#ffffff")};
  color: ${(props) => (props.$selected ? props.theme.colors.accent1 : props.theme.colors.font.tertiary)};
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    border-color: ${(props) => props.theme.colors.accentColor};
  }
`;

export const NpsScaleHint = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: ${(props) => props.theme.fontSizes.xsmall};
  color: ${(props) => props.theme.colors.font.grey2};
  margin-bottom: 1rem;
`;

export const QuestionBlock = styled.div`
  margin-bottom: 1rem;
`;

export const AnswerTextarea = styled.textarea`
  width: 100%;
  min-height: 3.5rem;
  resize: vertical;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.border};
  font-family: inherit;
  font-size: ${(props) => props.theme.fontSizes.small};

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.accentColor};
  }
`;

export const ChoiceRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const ChoiceButton = styled.button<{ $selected: boolean }>`
  padding: 0.5rem 0.875rem;
  border-radius: 999px;
  border: 1px solid ${(props) => (props.$selected ? props.theme.colors.accentColor : props.theme.colors.border)};
  background-color: ${(props) => (props.$selected ? props.theme.colors.accentColor : "#ffffff")};
  color: ${(props) => props.theme.colors.font.grey1};
  font-size: ${(props) => props.theme.fontSizes.small};
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    border-color: ${(props) => props.theme.colors.accentColor};
  }
`;

export const FormActions = styled.div<{ $spread?: boolean }>`
  display: flex;
  justify-content: ${(props) => (props.$spread ? "space-between" : "flex-end")};
  align-items: center;
  margin-top: 0.5rem;
`;

export const ManualFeedbackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0.875rem;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.border};
  background-color: #ffffff;
  color: ${(props) => props.theme.colors.font.tertiary};
  font-size: ${(props) => props.theme.fontSizes.small};
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    border-color: ${(props) => props.theme.colors.accentColor};
    color: ${(props) => props.theme.colors.font.grey1};
  }
`;

export const SubmittedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0.875rem;
  border-radius: 8px;
  color: ${(props) => props.theme.colors.font.tertiary};
  font-size: ${(props) => props.theme.fontSizes.small};
`;

export const FeedbackFooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  margin: 2.5rem 0 1rem;
  padding: 1.5rem;
`;

export const FeedbackFooterTitle = styled.h3`
  font-size: ${(props) => props.theme.fontSizes.medium};
  font-weight: 600;
  color: ${(props) => props.theme.colors.font.grey1};
  margin: 0;
`;

export const FeedbackFooterNpsRow = styled(NpsRow)`
  max-width: 420px;
  width: 100%;
  margin-bottom: 0;
`;

export const ModalFormWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 16px;
  padding: 0.2rem 0.625rem;
  width: calc(100% + 5rem);
  margin: -1.5rem -2.5rem;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    width: calc(100% + 3rem);
    margin: -1.5rem;
  }
`;
